<script setup lang="ts">
/**
 * Chip filtre cliquable. Visuel pilule avec état actif accent.
 */
defineProps<{
  active?: boolean;
  icon?: string;
  title?: string;
}>();
</script>

<template>
  <button
    type="button"
    :class="[
      'inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium',
      'border transition-colors duration-160',
      active
        ? 'bg-accent text-white border-accent'
        : 'bg-surface text-text-muted border-DEFAULT hover:border-strong hover:text-text',
    ]"
    :title="title"
  >
    <i v-if="icon" :class="['ti', icon]" aria-hidden="true"></i>
    <slot />
  </button>
</template>
